const EN_US_FORMATTER = new Intl.NumberFormat("en-US");

export function formatMatchCount(n: number): string {
  if (!Number.isFinite(n) || n < 0) {
    return EN_US_FORMATTER.format(0);
  }
  return EN_US_FORMATTER.format(Math.trunc(n));
}
